
let Config = {
    localApiURL: process.env.IN_APP_API_URL,
    publicApiURL: process.env.API_ALLGRADS_URL,
    projectId: process.env.PROJECT_ID,
    webSocketsUrl: process.env.WEBSOCKET_URL,
    isDev: process.env.IS_DEV == 'true',
    IS_WEBSOCKETS: process.env.IS_WEBSOCKETS == 'true',
    APP_VERSION: process.env.APP_VERSION
};

// if (window.location.hostname === "bookingsdev.allgraduates.com.au") {
//     Config.localApiURL = "https://bookingsdev.allgraduates.com.au/api/public/";
//     Config.publicApiURL = "http://apidev.allgraduates.com.au/";
//     Config.webSocketsUrl= "http://192.168.100.206:4999";

// }

// if (window.location.hostname === "localhost") {
//     Config.localApiURL = "http://localhost/SHORE_ALLGRADUATES/bookings/api/public/";
//     Config.publicApiURL = "http://localhost/SHORE_ALLGRADUATES/api.allgraduates.com.au/public/";
//     Config.webSocketsUrl= "ws://localhost:4999";
// }

// if (window.location.hostname === "localhost") {
//     Config.localApiURL = "http://localhost/SHORE_ALLGRADUATES/bookings/api/public/";
//     Config.publicApiURL = "http://localhost:8888/api.allgraduates.com.au/public/";
//     Config.webSocketsUrl= "http://localhost:4999";
// }

export default Config;



// WEBPACK FOOTER //
// ./src/config/config.js